import React from "react";
import { useCopy } from "../../lib/paymentCheck/i18n.jsx";
import protectionImage from "../../assets/askmax-protection-detail.png";

/**
 * Protection campaign image section — NEW (task brief §10). Uses the
 * Product-Owner-approved photograph: the lower black-and-white panel
 * of "ask max v2.3 images/a_cinematic_high_contrast_mostly_black_and_
 * white.png", extracted with a safety margin so no bleed from the two
 * upper case-study panels is present (see git history for the exact
 * crop). No guard branding or insignia appears in the source image.
 *
 * Responsive treatment is a single image with CSS `object-fit: cover`
 * + `object-position` inside a responsive aspect-ratio container —
 * deliberately NOT separate low-quality crops per device — so the
 * central figure and enough of the flanking figures stay legible on a
 * narrow phone, while desktop gets the full wide cinematic frame.
 */
export default function ProtectionSection() {
  const t = useCopy();

  return (
    <section className="pc-protection pc-zone--black-deep">
      <div className="pc-protection__media" aria-hidden="true">
        <img src={protectionImage} alt="" className="pc-protection__img" loading="lazy" />
      </div>
      <div className="pc-container pc-reading pc-protection__copy">
        <p className="pc-statement pc-statement--lg" style={{ marginTop: 0 }}>
          {t("protection_line1")}
        </p>
        <p className="pc-lede pc-lede--muted">{t("protection_line2")}</p>
        <p className="pc-lede pc-lede--muted">{t("protection_line3")}</p>
        <p className="pc-statement" style={{ fontSize: "var(--pc-text-lg)", textTransform: "none" }}>
          <span className="pc-statement--accent">{t("protection_line4")}</span>
        </p>
      </div>
    </section>
  );
}
